export default "__VITE_ASSET__Czaii9ic__"